import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/lib/api';

export function useAlerts(filters: { status?: string; severity?: string } = {}) {
  return useQuery({
    queryKey: ['alerts', filters],
    queryFn: () => api.get('/api/alerts', { params: filters }).then((r) => r.data),
    refetchInterval: 30_000,
  });
}

export function useOpenAlertCount() {
  return useQuery({
    queryKey: ['alerts', 'open-count'],
    queryFn: () => api.get('/api/alerts/open-count').then((r) => r.data.count as number),
    refetchInterval: 60_000,
  });
}

export function useResolveAlert() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ alertId, resolutionNote }: { alertId: string; resolutionNote: string }) =>
      api.put(`/api/alerts/${alertId}/resolve`, { resolutionNote }).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['alerts'] }),
  });
}

export function useAcknowledgeAlert() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (alertId: string) =>
      api.put(`/api/alerts/${alertId}/acknowledge`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['alerts'] }),
  });
}
